import React from 'react';
import { motion, Variants } from 'framer-motion';
import Navbar from './components/Navbar';
import Features from './components/Features';
import Footer from './components/Footer';
import { LandingTranslationProvider } from './contexts/LandingTranslationContext';

const pageVariants: Variants = {
  initial: {
    opacity: 0,
    x: -20
  },
  animate: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      ease: "easeOut" as const
    }
  },
  exit: {
    opacity: 0,
    x: 20,
    transition: {
      duration: 0.3,
      ease: "easeIn" as const
    }
  }
};

const About = () => {
  return (
    <LandingTranslationProvider>
      <div className="min-h-screen bg-gradient-to-r from-[#F6EAD1] to-[#99BAD4] overflow-hidden">
        <Navbar />
        <motion.div
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          <Features />
        </motion.div>
        <Footer />
      </div>
    </LandingTranslationProvider>
  );
};

export default About;